import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, money } from "@/lib/api";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function FreightQuotePage() {
  const { token } = useParams();
  const [q, setQ] = useState(null);
  const [err, setErr] = useState("");
  const load = () => api.get(`/shipping/freight-quote/${token}`).then((r) => setQ(r.data)).catch(() => setErr("This freight quote link is invalid or has expired."));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const decide = async (a) => {
    try { await api.post(`/shipping/freight-quote/${token}/${a}`); toast.success(a === "approve" ? "Thanks — freight approved" : "Freight declined — we'll be in touch"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not update"); }
  };
  return (
    <div className="min-h-screen bg-background"><Header />
      <div className="max-w-xl mx-auto px-4 py-12" data-testid="freight-quote-page">
        <h1 className="text-3xl font-extrabold mb-4">Freight quotation</h1>
        {err && <p className="text-red-700">{err}</p>}
        {q && (
          <div className="rounded-xl border bg-white p-6 space-y-3 text-sm">
            <p>Order <b className="font-mono">{q.order_number}</b></p>
            {q.freight_items?.length > 0 && <p className="text-muted-foreground">Freight items: {q.freight_items.map((f) => `${f.qty} × ${f.name}`).join(", ")}</p>}
            <div className="flex justify-between"><span>Freight charge (incl GST)</span><b className="font-mono" data-testid="freight-amount">{money(q.amount)}</b></div>
            <div className="flex justify-between"><span>New order total</span><b className="font-mono" data-testid="freight-new-total">{money(q.new_total)}</b></div>
            {q.note && <p className="text-muted-foreground">{q.note}</p>}
            {q.status === "proposed" ? (
              <div className="flex gap-3 pt-2">
                <Button className="bg-accent text-steel font-semibold" onClick={() => decide("approve")} data-testid="freight-approve">Approve freight charge</Button>
                <Button variant="outline" onClick={() => decide("decline")} data-testid="freight-decline">Decline</Button>
              </div>
            ) : <p className="font-semibold" data-testid="freight-status">Status: {q.status}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
